export const HEADER_CHAT_BELL_POPOVER_ID = 'header-chat-bell-popover';

export const HEADER_CHAT_BELL_UNREAD_MAX = 99;

export const POPOVER_ANCHOR_ORIGIN = { vertical: 'bottom', horizontal: 'right' };

export const POPOVER_TRANSFORM_ORIGIN = { vertical: 'top', horizontal: 'right' };
